import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWasmachine = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_5140_14764)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-0.027832 -0.027832H22.0279V22.0279H-0.027832V-0.027832ZM1.97217 1.97217V20.0279H20.0279V1.97217H1.97217Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0279 5.65414H0.972168V3.65414H21.0279V5.65414Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97251 7.5901C12.0087 5.25976 17.054 8.17261 17.054 12.8332C17.054 14.9962 15.9001 16.9949 14.0268 18.0764C9.99062 20.4066 4.94535 17.4938 4.94535 12.8332C4.94535 10.6702 6.09939 8.67155 7.97251 7.5901ZM15.054 12.8332C15.054 9.71223 11.6754 7.76161 8.97252 9.32215C7.71815 10.0464 6.94535 11.3848 6.94535 12.8332C6.94535 15.9542 10.3239 17.9048 13.0268 16.3444C14.2813 15.6201 15.054 14.2817 15.054 12.8332Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5140_14764">
        <rect
          width={22}
          height={22}
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWasmachine);

export default ForwardRef;
